import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import Common from "./Common";
import Auth from "./Auth";
import Users from "./Users";
import Tests from "./Tests";
import News from "./News";
import Events from "./Events";
import Media from "./Media";
import Banner from "./Banner";
import FormBuilder from "./FormBuilder";
import Tickets from "./Tickets";
import Hubble from "./Hubble";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    common: Common,
    auth: Auth,
    users: Users,
    tests: Tests,
    news: News,
    events: Events,
    media: Media,
    banner: Banner,
    formBuilder: FormBuilder,
    tickets: Tickets,
    hubble: Hubble
  });
